import { DialogContent } from "@mui/material";
import { memo } from "react";
import styles from "./dialog-components.module.scss";

const ContentSectionComponent: React.FC<
  React.PropsWithChildren<{ dividers?: boolean }>
> = ({ dividers, children }) => {
  return (
    <DialogContent dividers={dividers} className={styles.dialog}>
      {children}
    </DialogContent>
  );
};

export const ContentSection = memo(ContentSectionComponent);
